<template>
  <div
    class="d-flex flex-center py-2 px-6 border border-top-0 bg-white rounded-bottom"
  >
    <span class="svg-icon svg-icon-lg svg-icon-primary">
      <inline-svg src="media/svg/icons/General/Search.svg" />
    </span>
    <input
      :value="value"
      v-on="$listeners"
      type="text"
      class="form-control border-0 font-weight-bold pl-2"
      placeholder="Ketik nomor ponsel"
      autocomplete="off"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: "",
    },
  },
};
</script>
